import { LOCATION_ORIGIN } from '../../../call-api';

/** Production Engage host only (bundled nfib HTML points here). */
const PROD_ENGAGE_PREFIX = /^https?:\/\/engage\.nfib\.org(?=\/|$|\?|#)/i;

/**
 * True for /auth/login on any Engage host (engage.nfib.org or engage-{env}.nfib.org).
 */
export function isEngageNfibLoginPath(href) {
  const raw = (href || '').trim();
  if (!raw) {
    return false;
  }
  try {
    const u = new URL(raw, window.location.href);
    if (!/^engage(-[a-z0-9]+)?\.nfib\.org$/i.test(u.hostname)) {
      return false;
    }
    return u.pathname.indexOf('/auth/login') !== -1;
  } catch (e) {
    return false;
  }
}

/**
 * True for /auth/login on the current app origin (e.g. localhost, engage-dv, engage-qa).
 * This is needed because we rewrite https://engage.nfib.org/... to LOCATION_ORIGIN first.
 */
export function isCurrentOriginLoginPath(href, engageOrigin) {
  const raw = (href || '').trim();
  if (!raw) {
    return false;
  }
  const origin = (engageOrigin || LOCATION_ORIGIN || '').replace(/\/$/, '');
  if (!origin) {
    return false;
  }
  try {
    const u = new URL(raw, window.location.href);
    return u.origin === origin && u.pathname.indexOf('/auth/login') !== -1;
  } catch (e) {
    return false;
  }
}

/**
 * Rewrites https://engage.nfib.org/... to the current app origin (dv / qa / ua / prod Engage).
 * @param {ParentNode} root - Shadow root or document fragment containing nfib markup
 * @param {string} [engageOrigin]
 */
export function rewriteProductionEngageHostToOrigin(root, engageOrigin) {
  const origin = (engageOrigin || LOCATION_ORIGIN || '').replace(/\/$/, '');
  if (!root || !origin) {
    return;
  }
  root.querySelectorAll('a[href]').forEach(a => {
    const raw = (a.getAttribute('href') || '').trim();
    if (!raw || !PROD_ENGAGE_PREFIX.test(raw)) {
      return;
    }
    try {
      const u = new URL(raw);
      a.setAttribute(
        'href',
        origin + u.pathname + u.search + u.hash
      );
    } catch (e) {
      /* ignore malformed href */
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/NfibSiteChrome/engageEnvLinks.js